import { actionIcon, btnSecondary } from '@/components/record-sheet/styles'
import type { SheetAction } from '@/lib/sheet'
import { cn } from '@/lib/utils'

export function ActionButton({ action, onClick }: { action: SheetAction; onClick: () => void }) {
  const Icon = actionIcon(action.icon)
  return (
    <button
      type="button"
      className={cn(
        btnSecondary,
        action.danger &&
          'border-red-200 text-red-600 hover:bg-red-50 dark:border-red-900/40 dark:text-red-400 dark:hover:bg-red-500/10'
      )}
      onClick={onClick}
    >
      <Icon className="size-4" /> {action.label}
    </button>
  )
}
